import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useApi, fmtIST, MODE_LABEL, FAMILY_LABEL } from "@/lib/useApi";

export default function AttemptsPage() {
  const api = useApi();
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/attempts").then((r) => setRows(r.data)); }, [api]);
  return (
    <div className="space-y-6 max-w-5xl" data-testid="my-exams-page">
      <div>
        <h1 className="font-display font-bold text-2xl sm:text-3xl text-slate-900 tracking-tight">My exams</h1>
        <p className="text-slate-600 mt-2 text-sm">Every attempt you've started. In-progress attempts resume exactly where you left off.</p>
      </div>
      {rows && !rows.length && (
        <Card className="p-10 border-slate-200 text-center text-slate-600">No attempts yet. <Link to="/app/practice" className="text-blue-600 underline">Start practising</Link>.</Card>
      )}
      <div className="space-y-3">
        {(rows || []).map((a) => (
          <Card key={a.id} className="p-5 border-slate-200 flex flex-wrap items-center justify-between gap-3" data-testid={`attempt-row-${a.id}`}>
            <div>
              <p className="font-medium text-slate-900">{MODE_LABEL[a.mode]} · {FAMILY_LABEL[a.family]} · {a.subjects.join(", ")}</p>
              <p className="text-xs text-slate-500 mt-1">Started {fmtIST(a.started_at)} · {a.entitlement === "free" ? "free attempt" : a.entitlement}</p>
            </div>
            <div className="flex items-center gap-3">
              {a.status === "submitted" ? (
                <>
                  <span className="font-mono text-sm">{a.result?.score}/{a.result?.max_score}</span>
                  <Button size="sm" variant="outline" asChild><Link to={`/app/results/${a.id}`}>View result</Link></Button>
                </>
              ) : (
                <>
                  <Badge variant="outline" className="border-blue-200 bg-blue-50 text-blue-700">{a.status.replace("_", " ")}</Badge>
                  <Button size="sm" asChild className="bg-blue-600 hover:bg-blue-700 text-white"><Link to={`/exam/${a.id}`}>Resume</Link></Button>
                </>
              )}
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
